module.exports = __webpack_public_path__ + "img/house_and_funeral.3f5479e3.svg";